function initCountryFilter(container) {
  if (!container || container.dataset.countryFilterInitialized === 'true') return;
  container.dataset.countryFilterInitialized = 'true';

  const input = container.querySelector('[data-country-filter]');
  const emptyState = container.querySelector('[data-country-filter-empty]');
  const status = container.querySelector('[data-country-filter-status]');
  const items = Array.from(container.querySelectorAll('.disclosure-list__item'));

  if (!input || items.length === 0) return;

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function filterOptions() {
    const query = normalize(input.value);
    let visibleCount = 0;

    items.forEach((item) => {
      const option = item.querySelector('[data-search]');
      const haystack = option ? normalize(option.dataset.search) : '';
      const isMatch = query === '' || haystack.indexOf(query) !== -1;
      item.hidden = !isMatch;
      if (isMatch) visibleCount += 1;
    });

    if (emptyState) emptyState.hidden = visibleCount !== 0;
    if (status) status.textContent = visibleCount === 0 ? emptyState.textContent.trim() : '';
  }

  input.addEventListener('input', filterOptions);

  container.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      input.value = '';
      filterOptions();
    }
  });

  const button = container.querySelector('[data-disclosure-toggle]');
  if (button) {
    button.addEventListener('click', () => {
      input.value = '';
      filterOptions();
    });
  }
}

function initAllCountryFilters() {
  document.querySelectorAll('[data-disclosure-country]').forEach(initCountryFilter);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllCountryFilters);
} else {
  initAllCountryFilters();
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-disclosure-country]').forEach(initCountryFilter);
});
